var React = require('react');

function SChevronLeftMedium18N (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.68673,12.28268,7.40406,9l3.28267-3.28266A.9999.9999,0,0,0,9.28051,4.29546l-.00544.00542-3.9818,3.9918a.99964.99964,0,0,0-.001,1.4137l0,0,3.98035,3.99036a.9999.9999,0,1,0,1.41644-1.4117l-.00237-.00237Z","fill":"var(--iconFill, #464646)"}));
}

SChevronLeftMedium18N.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18"};

module.exports = SChevronLeftMedium18N;

SChevronLeftMedium18N.default = SChevronLeftMedium18N;
